import React, { Component } from "react";
import Context from "../../Context";
import Strings from "@my-dld/assets/strings";
import { Lookup } from "@eres/ejari-api/Entity";
import { populateLookup } from "../../Utils";
import { AlphaSortProcessor } from "@eres/ejari-api/Utils";
import { getLocalValue } from "@eres/core/dist/LocaleValue";
import { HTLookup } from "../../api/entities";
import { HTLookUps } from "../../api/constants";

interface Props {
	mode: "edit" | "view";
}

interface State {
	isLoading: boolean;
	requirements?: Lookup[];
	sRequirements: Lookup[];
}

class Requirements extends Component<Props, State> {
	static contextType = Context;
	context!: React.ContextType<typeof Context>;

	constructor( props: Props ) {
		super( props );
		this.state = {
			isLoading: true,
			sRequirements: [],
		};
	}

	componentDidMount() {
		populateLookup( HTLookUps.FINALIZED_REQUIREMENTS, {
			onLookup: ( lookup: HTLookUps | string, values: Lookup[] ) => {
				this.setState( {
					requirements: values,
					sRequirements: this.getSelectedRequirements( values ),
					isLoading: false,
				} );
			}
		}, AlphaSortProcessor );
	}

	render() {
		if ( this.props.mode === "view" ) {
			return <RenderInfo state={ this.state }/>;
		}
		const { requirements, sRequirements, isLoading } = this.state;
		return <div className="card mb-3">
			<div className="card-header">
				<span>{ Strings.finalize_requirements }</span>
			</div>
			<div className="card-body">
				{ isLoading && <span className="spinner-border"/> }
				{ requirements && <div className="bg-light p-2 d-inline-block">
					{ requirements.map( req => {
						const isSelected = sRequirements.find( sReq => sReq.Id === req.Id ) !== undefined;
						return <div key={ `${ req.Id }` } className="form-check" onClick={ e => {
								e.preventDefault();
								this.onClick( req, isSelected );
							} }>
                                <input style={ { pointerEvents: "none" } } className="form-check-input" type="checkbox" checked={ isSelected }
								readOnly={ true }/>
                        <label className="form-check-label" htmlFor={ `${ req.Id }` }>{ getLocalValue( req ) }</label>
                    </div>;
					} ) }
				</div> }
			</div>
		</div>;
	}

	public getRequirements(): Promise<HTLookup[]> {
		const { isLoading, sRequirements } = this.state;
		if ( isLoading ) {
			return Promise.reject( "Requirements Not Valid" );
		}
		const sReq: HTLookup[] = [];
		if ( sRequirements && sRequirements.length > 0 ) {
			sRequirements.forEach( req => {
				sReq.push( {
					Identity: req.Id,
					NameEn: getLocalValue( req, "en" ),
					NameAr: getLocalValue( req, "ar" ),
				} );
			} );
		}
		return Promise.resolve( sReq );
	}

	private getSelectedRequirements( values: Lookup[] ) {
		const { request } = this.context;
		const sRequirements: Lookup[] = [];
		request?.FinalizedRequirements?.forEach( req => {
			const requirement = values.find( value => value.Id === req.Identity );
			if ( requirement ) {
				sRequirements.push( requirement );
			}
		} );
		return sRequirements;
	}

	private onClick = ( sReq: Lookup, isSelected: boolean ) => {
		let requirements: Lookup[] = this.state.sRequirements;
		if ( isSelected ) {
			requirements = requirements.filter( req => req.Id !== sReq.Id );
		} else {
			requirements.push( sReq );
		}
		this.setState( {
			sRequirements: requirements,
		} );
	};
}

function RenderInfo( props: { state: State } ) {
	const { sRequirements } = props.state;
	if ( sRequirements && sRequirements.length > 0 ) {
		return <>
			<div className="section-title">
				<h5>{ Strings.finalize_requirements }</h5>
			</div>
			<div className="card mb-3">
				<div className="card-body">
					<div className="bg-light p-2 d-inline-block">
						{ sRequirements.map( req => {
							return<div key={ `${ req.Id }` } style={ { pointerEvents: "none" } } className="form-check">
                                <input className="form-check-input" type="checkbox" value="" id={ `${ req.Id }` } checked={ true } readOnly={ true }/>
                                <label className="form-check-label" htmlFor={`${req.Id}`}>
                                    {getLocalValue(req)}
                                </label>
                            </div>;
						} ) }
					</div>
				</div>
			</div>
		</>;
	}
	return null;
}

export default Requirements;
